<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-avatar class="ml-4" v-bind="attrs" v-on="on" size="40px">
        <v-img v-if="image" :src="image"></v-img>
        <v-icon v-else>
          {{ icons.mdiAccountOutline }}
        </v-icon>
      </v-avatar>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-avatar v-if="image" size="40px" class="ml-2">
          <v-img :src="image"></v-img>
        </v-avatar>
        <v-avatar v-else size="40px" class="ml-2 pa-3" color="primary">
          <v-icon color="white" size="28px">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-avatar>

        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align: middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ user.first_name }} {{ user.last_name }}
          </span>
          <small class="text--disabled text-capitalize">
            <!-- {{ user.title }} -->
          </small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <v-list-item :to="{ name: 'profile' }">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Omat tiedot") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Logout -->
      <v-list-item :to="{ name: 'auth-logout' }">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Kirjaudu ulos") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from "@mdi/js";
import router from "@/router";
import useAuth from "@/useAuth";
import { computed, onMounted } from "@vue/composition-api";

export default {
  setup() {
    const { user } = useAuth();

    const logout = () => {
      router.replace({ name: "auth-login" });
    };

    onMounted(() => {
      // alert(JSON.stringify(user));
    });

    const image = computed(() => {
      if (user.value.picture && Object.keys(user.value).length) {
        return user.value.picture.thumbnail;
      }
      return null;
    });

    return {
      user,
      image,
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },

      logout,
    };
  },
};
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
